import validator from 'validator';

const E_EMPTY_STATE = 'You must provide the address state';
const E_EMPTY_STREET = 'You must provide the address street';
const E_EMPTY_SUBURB = 'You must provide the address suburb';
const E_EMPTY_POST = 'You must provide the address postcode';
const E_EMPTY_STREET_NO = 'You must provide a street number or a lot number';

const isEmpty = (value) => validator.isEmpty(value, { ignore_whitespace: true });

export const validate = (values) => {
  var errors = {};

  if (isEmpty(values.address_street_no || '') && isEmpty(values.address_lot || '')) {
    errors.address_street_no = E_EMPTY_STREET_NO;
    errors.address_lot = E_EMPTY_STREET_NO;
  }

  if (isEmpty(values.address_street_1 || '')) {
    errors.address_street_1 = E_EMPTY_STREET;
  }

  if (isEmpty(values.address_suburb || '')) {
    errors.address_suburb = E_EMPTY_SUBURB;
  }

  if (isEmpty(values.address_state || '')) {
    errors.address_state = E_EMPTY_STATE;
  }

  if (isEmpty(values.address_postcode || '')) {
    errors.address_postcode = E_EMPTY_POST;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
